// extracted by mini-css-extract-plugin
module.exports = {"logo":"join-waitlist_logo__uUan2","form":"join-waitlist_form__6wQPL","arrowIcon":"join-waitlist_arrowIcon__0BJUj","link":"join-waitlist_link__YpbeC"};